<script lang="ts">

    export let bearing: number = 0;

</script>

<div class="compass" on:click>
    <img src="/images/compass.svg" alt="" style="transform: rotate({bearing}deg);">
</div>

<style lang="scss">

    $size: 75px;

    .compass {
        width: $size;
        height: $size;
    }

    img {
        width: 100%;
        height: 100%;
        filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.25));
    }

</style>